import { Lesson } from "@jelly/lesson";
import config from "appConfig";
import { task } from "../../../task/course-02/lesson-01/task-01";
import theory from "./theory";

const lesson: Lesson = {
  id: "6520d845-cfe7-46f3-9294-f9b00a3e9860",
  publicId: "1",
  name: "Anatomy of the ear",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [
    {
      title: "",
      description:
        "This is an approximate visualisation of the cochlea and the basilar membrane. The outermost part of the basilar membrane is sensitive to higher frequencies (20 kHz) while the inner part is sensitive to the lower frequencies (20 Hz). This is called the place principle.  The place on the spiral match the value on the linear scale below.",
      layout: {
        type: "slidersToggle",
        options: {
          controlsPosition: "bottom",
          defaultIndex: [11],
          labels: [
            [
              {
                name: "200",
              },
              {
                name: "400",
              },
              {
                name: "600",
              },
              {
                name: "800",
              },
              {
                name: "1000",
              },
              {
                name: "1500",
              },
              {
                name: "2000",
              },
              {
                name: "3000",
              },
              {
                name: "4000",
              },
              {
                name: "5000",
              },
              {
                name: "7000",
              },
              {
                name: "20000",
              },
            ],
          ],
          components: [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-200.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-400.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-600.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-800.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-1000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-1500.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-2000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-3000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-4000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-5000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-7000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/01/principle/ear-20000.svg`,
                    viewType: "fill",
                  },
                },
              },
            },
          ],
        },
      },
      theory,
    },
    {
      title: "Which of these pictures correspond with their description?",
      description: "Drag and drop descriptions.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
